import {
  Button,
  Col,
  Form,
  message,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { columns } from "../constants/data/organizationTable";
import * as MESSAGES from "../constants/messages";
import * as ROUTES from "../constants/routes";
import { PlusOutlined } from "@ant-design/icons/lib/icons";
import {
  fetchAllOrganization,
  updateOrganization,
} from "../redux/actions/organizationActions";
import OrganizationFilterForm from "../components/forms/OrganizationFilterForm";
import {
  DEFAULT_TABLE_PAGINATION_DROPDOWN_PAGE_COUNT,
  PAGES_CODE as PAGES,
} from "../constants/pages";
import {
  globalPagesFilterData,
  globalPagesPagination,
} from "../redux/actions/globalReducActions";
import {
  CaretLeftOutlined,
  CaretRightOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { TableDropdown } from "../components/common/TableDropDown";

function OrganizationManagementScreen() {
  const [loading, setLoading] = useState(false);
  const [organizationData, setOrganizationData] = useState({});
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const tablePaginationParams = useSelector(
    (state) => get(state, "global.globalPagesPagination")[PAGES.ORGANISATION]
  );
  const activeFilters = useSelector(
    (state) => get(state, "global.globalPagesFilterData")[PAGES.ORGANISATION]
  );
  const setTablePaginationParams = (param) => {
    if (param && typeof param == "function") {
      dispatch(
        globalPagesPagination(PAGES.ORGANISATION, param(tablePaginationParams))
      );
    } else {
      dispatch(globalPagesPagination(PAGES.ORGANISATION, param));
    }
  };
  const setActiveFilters = (param) => {
    if (param && typeof param == "function") {
      dispatch(globalPagesFilterData(PAGES.ORGANISATION, param(activeFilters)));
    } else {
      dispatch(globalPagesFilterData(PAGES.ORGANISATION, param));
    }
  };
  useEffect(() => {
    getOrganizationList();
  }, [tablePaginationParams]);
  const onClickEdit = (record) => {
    const id = get(record, "id", 0);
    navigate({
      pathname: ROUTES.EDIT_ORGANIZATION,
      search: `${id}`,
    });
  };

  const onChangeHandler = (record) => {
    const payload = { is_active: !get(record, "is_active", false) };
    toggleActive(payload, get(record, "id", 0));
  };

  const getOrganizationList = () => {
    let params = {
      ...tablePaginationParams,
    };
    setLoading(true);
    dispatch(fetchAllOrganization(params))
      .then((result) => {
        setOrganizationData(result);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const toggleActive = (payload, id) => {
    setLoading(true);
    dispatch(updateOrganization(payload, id))
      .then(() => {
        message.success(MESSAGES.ACTIVE_UPDATE_MESSAGE);
        setLoading(false);
        getOrganizationList();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getOrganizationList();
  }, []);
  const setTableSortingParams = (field, order) => {
    setTablePaginationParams((prevState) => {
      return {
        ...prevState,
        sortBy: order ? field : undefined,
        sortDir: order ? (order === "ascend" ? "ASC" : "DESC") : undefined,
      };
    });
  };
  return (
    <div className="main-wrapper-div drawer">
      <div>
        <h1 className="title">Organization Management </h1>
      </div>
      <div className="add-button-container">
        <Button
          className="main-button"
          size="large"
          onClick={() => {
            navigate(ROUTES.ADD_ORGANIZATION);
          }}
        >
          ADD NEW ORGANIZATION
          <PlusOutlined />
        </Button>
      </div>

      <OrganizationFilterForm
        form={form}
        setActiveFilters={setActiveFilters}
        setTablePaginationParams={setTablePaginationParams}
        tablePaginationParams={tablePaginationParams}
        activeFilters={activeFilters}
      />

      <div className="user-table">
        <Table
          showSorterTooltip={false}
          rowKey="id"
          size="small"
          dataSource={get(organizationData, "data")}
          pagination={false}
          scroll={{ y: "calc(100vh - 430px)" }}
          columns={columns({
            onClickEdit,
            onChangeHandler,
            organizationData,
          })}
          onChange={(a, b, sorting) =>
            setTableSortingParams(sorting.field, sorting.order)
          }
          loading={loading}
          footer={() => (
            <Row justify={"space-between"}>
              <Col>
                <Space>
                  <TableDropdown
                    itemsArr={DEFAULT_TABLE_PAGINATION_DROPDOWN_PAGE_COUNT}
                    itemOnClick={setTablePaginationParams}
                    tablePaginationParams={tablePaginationParams}
                  />
                  <Typography>{`${get(organizationData, "offset", 0) + 1} to ${
                    get(organizationData, "data", []).length +
                    get(organizationData, "offset", "--")
                  } of ${get(
                    organizationData,
                    "total",
                    "--"
                  )} items`}</Typography>
                </Space>
              </Col>
              <Col>
                <Button.Group>
                  <Button
                    type="ghost"
                    icon={<CaretLeftOutlined />}
                    onClick={() =>
                      setTablePaginationParams({
                        ...tablePaginationParams,
                        offset:
                          get(organizationData, "offset", 0) -
                          get(organizationData, "limit", 0),
                      })
                    }
                    disabled={!get(organizationData, "offset", 0)}
                  />
                  <Button
                    type="ghost"
                    icon={<CaretRightOutlined />}
                    onClick={() =>
                      setTablePaginationParams({
                        ...tablePaginationParams,
                        offset:
                          get(organizationData, "offset", 0) +
                          get(organizationData, "limit", 0),
                      })
                    }
                    disabled={
                      get(organizationData, "offset", 0) +
                        get(organizationData, "limit", 0) >=
                      get(organizationData, "total", 0)
                    }
                  />
                </Button.Group>
              </Col>
            </Row>
          )}
        />
      </div>
    </div>
  );
}

export default OrganizationManagementScreen;
